"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemerWrapper = exports.findRedeemerKey = exports.findMinterAddress = void 0;
const tslib_1 = require("tslib");
const anchor_1 = require("@project-serum/anchor");
const solana_contrib_1 = require("@saberhq/solana-contrib");
const token_utils_1 = require("@saberhq/token-utils");
const web3_js_1 = require("@solana/web3.js");
const __1 = require("..");
const findMinterAddress = (wrapper, authority, programID = __1.SUNNY_ADDRESSES.SunnyMintWrapper) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return yield web3_js_1.PublicKey.findProgramAddress([
        Buffer.from(anchor_1.utils.bytes.utf8.encode("MintWrapperMinter")),
        wrapper.toBytes(),
        authority.toBytes(),
    ], programID);
});
exports.findMinterAddress = findMinterAddress;
const findRedeemerKey = ({ iouMint, redemptionMint, }) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    return web3_js_1.PublicKey.findProgramAddress([
        anchor_1.utils.bytes.utf8.encode("Redeemer"),
        iouMint.toBytes(),
        redemptionMint.toBytes(),
    ], new web3_js_1.PublicKey(__1.SUNNY_ADDRESSES.SunnyQuarryRedeemer));
});
exports.findRedeemerKey = findRedeemerKey;
class RedeemerWrapper {
    constructor(sdk, redeemer, iouMint, redemptionMint, data) {
        this.sdk = sdk;
        this.program = sdk.programs.SunnyQuarryRedeemer;
        this.iouMintKey = iouMint;
        this.redemptionMintKey = redemptionMint;
        this.key = redeemer;
        this.data = data;
    }
    static load(args) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const { iouMint, redemptionMint, sdk } = args;
            const [redeemer] = yield (0, exports.findRedeemerKey)({ iouMint, redemptionMint });
            const program = sdk.programs.SunnyQuarryRedeemer;
            const data = yield program.account.redeemer.fetch(redeemer);
            return new RedeemerWrapper(sdk, redeemer, iouMint, redemptionMint, data);
        });
    }
    static createRedeemer(ctorArgs) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const { iouMint, redemptionMint, sdk } = ctorArgs;
            const { provider } = sdk;
            const [redeemer, bump] = yield (0, exports.findRedeemerKey)({ iouMint, redemptionMint });
            const instructions = [];
            const { address, instruction } = yield (0, token_utils_1.getOrCreateATA)({
                provider,
                mint: redemptionMint,
                owner: redeemer,
            });
            if (instruction) {
                instructions.push(instruction);
            }
            instructions.push(sdk.programs.SunnyQuarryRedeemer.instruction.createRedeemer(bump, {
                accounts: {
                    redeemer,
                    iouMint,
                    redemptionMint,
                    redemptionVault: address,
                    payer: provider.wallet.publicKey,
                    systemProgram: web3_js_1.SystemProgram.programId,
                },
            }));
            return {
                bump,
                ctorArgs,
                tx: new solana_contrib_1.TransactionEnvelope(sdk.provider, instructions),
            };
        });
    }
    /**
     * redeemTokensIx
     */
    redeemTokensIx(args) {
        return this.program.instruction.redeemTokens(args.tokenAmount, {
            accounts: this.getRedeemTokenAccounts(args),
        });
    }
    /**
     * redeemTokensFromMintProxyIx
     */
    redeemTokensFromMintWrapperIx(args) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.program.instruction.redeemTokensFromMintWrapper(args.tokenAmount, {
                accounts: {
                    redeemCtx: this.getRedeemTokenAccounts(args),
                    minter: yield this.findMinterAddress(),
                    mintWrapper: __1.MINT_WRAPPER_KEY,
                    mintWrapperProgram: this.sdk.programs.SunnyMintWrapper.programId,
                },
            });
        });
    }
    /**
     * Finds the address of the Minter of this redeemer.
     * @returns
     */
    findMinterAddress() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const [minter] = yield (0, exports.findMinterAddress)(__1.MINT_WRAPPER_KEY, this.key, this.sdk.programs.SunnyMintWrapper.programId);
            return minter;
        });
    }
    /**
     * redeemAllTokensFromMintProxyIx
     */
    redeemAllTokensFromMintWrapperIx(args) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return this.program.instruction.redeemAllTokensFromMintWrapper({
                accounts: {
                    redeemCtx: this.getRedeemTokenAccounts(args),
                    minter: yield this.findMinterAddress(),
                    mintWrapper: __1.MINT_WRAPPER_KEY,
                    mintWrapperProgram: this.sdk.programs.SunnyMintWrapper.programId,
                },
            });
        });
    }
    /**
     * redeemTokensFromMintProxy
     */
    redeemTokensFromMintProxy({ amount, sourceAuthority = this.sdk.provider.wallet.publicKey, } = {
        sourceAuthority: this.sdk.provider.wallet.publicKey,
    }) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const atas = yield (0, token_utils_1.getOrCreateATAs)({
                provider: this.sdk.provider,
                mints: {
                    iou: this.data.iouMint,
                    redemption: this.data.redemptionMint,
                },
                owner: sourceAuthority,
            });
            const commonArgs = {
                sourceAuthority,
                iouSource: atas.accounts.iou,
                redemptionDestination: atas.accounts.redemption,
            };
            const redeemIX = amount
                ? yield this.redeemTokensFromMintWrapperIx(Object.assign(Object.assign({}, commonArgs), { tokenAmount: amount }))
                : yield this.redeemAllTokensFromMintWrapperIx(commonArgs);
            return new solana_contrib_1.TransactionEnvelope(this.sdk.provider, [
                ...atas.instructions,
                redeemIX,
            ]);
        });
    }
    getRedeemTokenAccounts(args) {
        const { iouSource, redemptionDestination, sourceAuthority } = args;
        return {
            redeemer: this.key,
            tokens: {
                iouMint: this.data.iouMint,
                redemptionMint: this.data.redemptionMint,
                redemptionVault: this.data.redemptionVault,
                tokenProgram: token_utils_1.TOKEN_PROGRAM_ID,
            },
            sourceAuthority,
            iouSource,
            redemptionDestination,
        };
    }
}
exports.RedeemerWrapper = RedeemerWrapper;
//# sourceMappingURL=redeemer.js.map